import http from '@/requests/http'

class Level {
  static all (params) {
    return http.post('configuration/member/level/index', params)
  }
  static async view (params) {
    return http.post('configuration/member/level/view', params)
  }
  static async update (data) {
    return http.post('configuration/member/level/update', data)
  }
  static async save (data) {
    return http.post('configuration/member/level/store', data)
  }
  static async destroy (id) {
    return http.post(`configuration/member/level/delete/${id}`)
  }
}

export default Level
